import type { RuleSet } from 'styled-components'
import { css, styled } from 'styled-components'
import * as iconGlyphs from '../../icons/generated'
import { withStyleModifiers } from '../../utils/typescript'

const iconSizes = {
  'xs': '12px',
  'sm': '16px',
  'md': '24px',
  'lg': '32px',
  'xl': '40px',
  '2xl': '48px',
}

export type IconSize = keyof typeof iconSizes
export type IconGlyph = keyof typeof iconGlyphs

const IconWrapper = styled.span<{ $size?: IconSize }>`
  display: inline-flex;
  flex-shrink: 0;

  ${({ $size }) => modSize($size)}
`

export interface IconProps extends React.SVGAttributes<SVGElement> {
  className?: string
  glyph: IconGlyph
  size?: IconSize
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * Use Icon component from UDS.
 */
function Icon({ className, glyph, size, ...attrs }: IconProps) {
  const GlyphComponent = iconGlyphs[glyph]

  if (GlyphComponent === undefined) {
    console.error(`Icon: No icon found for glyph "${glyph}"`)
    return null
  }

  return (
    <IconWrapper className={className} $size={size}>
      <GlyphComponent {...attrs} />
    </IconWrapper>
  )
}

Icon.displayName = 'Icon'

function modSize(sizeName: IconSize = 'sm'): RuleSet<object> {
  return css`
  & > svg {
    height: ${iconSizes[sizeName]};
    width: ${iconSizes[sizeName]};
  }
`
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * Use Icon component from UDS.
 */
const StyledIcon = withStyleModifiers(styled(Icon)``, {
  modSize,
})

export default StyledIcon
